import React, { useContext, useReducer } from "react";

const ModalContext = React.createContext();

const ModalReducer = (modalState, action) => {
  if (action.type === "SHOW_ERROR") {
    return {
      ...modalState,
      showModal: true,
      modalIsError: true,
      modalText: action.payload,
    };
  }
  if (action.type === "SHOW_SUCCESS") {
    return {
      ...modalState,
      showModal: true,
      modalIsError: false,
      modalText: action.payload,
    };
  }
  if (action.type === "CLOSE_MODAL") {
    return {
      ...modalState,
      showModal: false,
      modalIsError: false,
      modalText: "",
    };
  }

  throw new Error("No matching action type");
};
const defaultState = {
  showModal: false,
  modalIsError: false,
  modalText: "",
};

export function useModal() {
  return useContext(ModalContext);
}

export function ModalProvider({ children }) {
  const [modalState, modalDispatch] = useReducer(ModalReducer, defaultState);

  const value = { modalState, modalDispatch };

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
}
